<template>
    <a class="result result--product" :href="result.url">
        <div class="row">
            <div class="col-4">
                <img :src="result.thumbnail || 'http://via.placeholder.com/150x150'" :alt="result.name" class="mw-100 h-auto">
            </div>
            <div class="col-8">
                <!-- Highlight -->
                <h5 class="result-name" v-html="result.name">
                </h5>
                <!-- Highlight -->
                <h6 class="result-brand-name" v-html="result.brand_name">
                </h6>
                <div>
                    <!-- Highlight -->
                    <small v-html="result.group">
                    </small>
                </div>
                <!-- Snippet description (= "... text ...") -->
                <div class="result-description mt-2" v-html="result.description">
                </div>
            </div>
        </div>
    </a>
</template>

<script>
    export default {
        props: {
            result: Object
        }
    }
</script>
